/**
 * Checks if any of the provided emails belong to a Plans employee
 * @param emails Array of email addresses to check (can include undefined values)
 * @returns Boolean indicating if any email belongs to a Plans employee
 */
export function isInternalEmployee(emails: Array<string | undefined>): boolean {
	// `@lun.energy` is the pre-rename domain and is still a real one — calor's
	// own internal-user backfill matched `%@lun.energy%` OR `%@plans.app%`.
	// It reads `@plans.energy` in the history because NG-3106's blanket
	// find-and-replace on the string "lun" rewrote the value; `@plans.energy`
	// issues no mailboxes, so for a year this arm matched nobody and any
	// remaining legacy account silently failed the gate.
	const legacyLunDomain = "@lun.energy";
	const plansDomain = "@plans.app";

	// Match the domain as a suffix, not a substring: `endsWith` rejects lookalikes
	// like `attacker@plans.appmalicious.com` that `includes` would accept — this
	// gate now also guards an internet-facing internal-only route (`/:slug/forms`).
	return emails
		.filter(Boolean) // Remove undefined/null values
		.some(
			(email) =>
				email?.endsWith(legacyLunDomain) || email?.endsWith(plansDomain),
		);
}
